/**
 * @author limy
 */
import api from '@/services/api'
import {METHOD, request} from '@/utils/request'

export const dataApi = {
    async custAssignRecord() { // 离职员工已分配记录
        return request(api.client.SCRM + "/custAssignRecord", METHOD.GET);
    },
    async getSonTableList(keyId) {
        return request(api.client.INHERIT + '/getUserUnAssignCust?userId=' + keyId, METHOD.GET);
    },
    async getRecordSonTableList(keyId) {
        return request(api.client.SCRM + '/custAssignRecord/getDetailPageList?userId=' + keyId, METHOD.GET);
    },
    async selection(params) {
        return request(api.client.SELECTION, METHOD.GET, params)
    },
    async saveAssignResult(userId,result) { // 从离职员工 分配继承员工 userId 分配接收人；result 离职员工（可多人）
        return request(api.client.SCRM + "/custAssignRecord/saveRecordByUserId?userId="+userId, METHOD.POST, result);
    },
    async saveCustAssignResult(userId,result) { // 从离职员工的客户 分配继承员工 userId 分配接收人；result 客户（可多人）
        return request(api.client.SCRM + "/custAssignRecord/saveRecordByCustId?userId="+userId, METHOD.POST, result);
    },
}

export default {dataApi}
